import l from "./index246.js";
import { createElementBlock as t, openBlock as o, Fragment as s, renderList as c, createBlock as d, createCommentVNode as i, createElementVNode as r, resolveDynamicComponent as p, toDisplayString as a } from "vue";
import m from "./index231.js";
const u = ["data-component"], f = { class: "font-bold text-text-l whitespace-nowrap" }, _ = { class: "whitespace-nowrap text-color-neutral-grey-60" };
function g(n, h, w, b, k, v) {
  return o(), t("div", {
    "data-component": n.$options.name,
    class: "grid grid-cols-2 gap-1 overflow-hidden border border-solid border-color-neutral-gray-10 bg-color-neutral-grey-10 rounded-10"
  }, [
    (o(!0), t(s, null, c(n.filledEntries, (e) => (o(), t("div", {
      key: e.label,
      class: "flex items-center gap-16 px-16 py-8 bg-color-neutral-white"
    }, [
      e.markedRawIconComponent ? (o(), d(p(e.markedRawIconComponent), {
        key: 0,
        class: "w-24 h-24 shrink-0"
      })) : i("", !0),
      r("div", null, [
        r("div", f, a(e.value), 1),
        r("div", _, a(e.label), 1)
      ])
    ]))), 128))
  ], 8, u);
}
const y = /* @__PURE__ */ m(l, [["render", g]]);
export {
  y as default
};
